

































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { MerchantDetailsModel } from '@/models/MerchantDetailsModel';

type CategoryValue = { name: string; id: number };

@Component
export default class MenuSelect extends Vue {
  @Prop() private activeCategoryId!: string | null;

  @Prop() private categoryIdPrefix!: string;

  private value: CategoryValue | null = null;

  private timeout: number | null = null;

  @Watch('activeCategoryId')
  private onActiveCategoryIdChanged(id: string): void {
    const newVal = this.submenus.find((e) => e.id === Number(id)) || null;
    this.startTransition(this.value, newVal);
    this.value = newVal;
  }

  private get merchant(): MerchantDetailsModel {
    return this.$store.state.merchant.merchant;
  }

  private get submenus(): CategoryValue[] {
    return this.merchant.menus
      .filter((e) => e.visible)
      .flatMap((e) => e.submenus.map(({ name, id }) => ({ id, name: name.toLowerCase() })));
  }

  private async onSelected(value: CategoryValue): Promise<string> {
    return this.$vuetify.goTo(`#${this.categoryIdPrefix}${value.id}`, { offset: 64, duration: 1000, easing: 'easeInCubic' });
  }

  private startTransition(oldValue: CategoryValue | null, newValue: CategoryValue | null): void {
    if (oldValue === newValue) return;

    let up: boolean;
    if (!newValue) {
      up = true;
    } else if (!oldValue) {
      up = false;
    } else {
      up = this.submenus.indexOf(oldValue) > this.submenus.indexOf(newValue);
    }

    const el = (this.$refs.categoryRef as HTMLSpanElement);

    el.style.transition = 'opacity 100ms ease-out';
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;

      el.style.opacity = '0.5';
      el.style.transform = `translate3d(0px, ${up ? '-' : ''}40%, 0px)`;
    } else {
      el.style.opacity = '0';
      el.style.transform = `translate3d(0px, ${up ? '-' : ''}70%, 0px)`;
    }

    this.timeout = setTimeout(() => {
      el.style.transition = 'opacity 150ms ease-out, transform 150ms ease-out';
      el.style.opacity = '1';
      el.style.transform = 'translate3d(0px, 0%, 0px)';
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    }, 50);
  }
}
